import { Grid, Card } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade} from '../../../../../../features/global/globalDataSlice'
import { selectMyContractsState, resetSelectedContractInfo } from '../../../../../../features/myContracts/myContractsSlice'
import SingleExpandedInvoice from '../../SingleExpandedInvoice'
import VodafoneInvoiceList from './VodafoneInvoiceList'
import Lottie from "lottie-react";
import VodafoneTopup from './VodafoneTopup'
import smallLoadingAnimation from '../../../../../../icons/lottieAnimations/smallLoading.json'
import { selectVodafoneTopupState, displayInvoiceList, displaySingleInvoice, displayMainUtilityView, resetVodafoneTopUpSlice } from '../../../../../../features/vodafone/vodafoneTopupSlice'
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice'
import MyContractsTest from '../../myContracts/myContractsNew/MyContractsTest'
import { texts } from '../../../../../general/texts';

export const UtilityVodafoneTopup = (props) => {
    const vodafoneTopupSliceState = useSelector(selectVodafoneTopupState)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const utilityName = 'VODAFONE'

    React.useEffect(()=>{
        vodafoneTopupSliceState.shouldDisplaySingleInvoice && dispatch(displaySingleInvoice())
        vodafoneTopupSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        vodafoneTopupSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())

        if(vodafoneTopupSliceState.isOfferTransactionSuccessfullyCompleted)
        {
            dispatch(setTransactionHasBeenMade(true))
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(resetVodafoneTopUpSlice())
        }

        return(()=>{
            dispatch(resetSelectedContractInfo())
        })
    }, [vodafoneTopupSliceState.isOfferTransactionSuccessfullyCompleted, vodafoneTopupSliceState.shouldDisplaySingleInvoice, vodafoneTopupSliceState.shouldDisplayInvoiceList, vodafoneTopupSliceState.shouldDisplayMainUtilityView])


  return (
    <Grid container spacing={'2%'} pt={'3%'} >
        <Grid container item md={6.5} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
            <Card sx={{borderRadius:'20px', boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                {vodafoneTopupSliceState.shouldDisplayInvoiceList === false && vodafoneTopupSliceState.shouldDisplaySingleInvoice === false && <VodafoneTopup selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={props.defaultButtonStyle} selectedButtonStyle={props.selectedButtonStyle} vodafoneTopupSliceState={vodafoneTopupSliceState} utilityInfo={props.utilityInfo} globalDataSliceState={globalDataSliceState}/>}
                {vodafoneTopupSliceState.shouldDisplayInvoiceList === true && <VodafoneInvoiceList utilityInfo={props.utilityInfo} utilityName={utilityName} globalDataSliceState={globalDataSliceState} vodafoneTopupSliceState={vodafoneTopupSliceState}/>}  
                {vodafoneTopupSliceState.shouldDisplaySingleInvoice === true && <SingleExpandedInvoice utilityName={utilityName} invoice={vodafoneTopupSliceState.singleInvoice} globalDataSliceState={globalDataSliceState} vodafoneTopupSliceState={vodafoneTopupSliceState}/>}  
                <Grid container justifyContent={'center'}>
                <Grid item md={3} xs={3}>
                {vodafoneTopupSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
            </Grid> 
                            
            </Card>            
        </Grid>
        <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
            <MyContractsTest utilityName={utilityName} currentLocation='utility'/>
        </Grid>
    </Grid> 
  )
}
export default UtilityVodafoneTopup